import { Color } from '@persona-id/design-tokens';
import { FC, KeyboardEventHandler, PropsWithChildren, useRef } from 'react';
import styled from 'styled-components';

const TabBarContainer = styled.div`
  display: flex;
  background: ${Color.CoreSlate50};
`;

const getIndex = (children: Element[], element: Element) => {
  return children.indexOf(element);
};

const getTabList = (list: HTMLCollection) => {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  return Array.from(list).filter((e: HTMLElement) => {
    return !(e.getAttribute('aria-disabled') || e.getAttribute('disabled'));
  });
};

interface TabBarSwitchProps {}

const TabBarSwitch: FC<PropsWithChildren<TabBarSwitchProps>> = ({ children, ...elemProps }) => {
  const tabListRef = useRef<HTMLDivElement>(null);

  const getIndexOfCurrentTab = (list: Element[]) => {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    return getIndex(list, document.activeElement);
  };

  const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (e) => {
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const list = getTabList(tabListRef.current.children);

    switch (e.key) {
      case 'ArrowLeft': {
        // Go to previous tab
        const curIndex = getIndexOfCurrentTab(list);
        const nextIndex = curIndex === 0 ? list.length - 1 : curIndex - 1;
        (list[nextIndex] as HTMLElement).focus();
        break;
      }
      case 'ArrowRight': {
        // Go to next tab
        const curIndex = getIndexOfCurrentTab(list);
        (list[(curIndex + 1) % list.length] as HTMLElement).focus();
        break;
      }
      case 'Home': {
        // Go to first tab
        (list[0] as HTMLElement).focus();
        break;
      }
      case 'End': {
        // Go to last tab
        (list[list.length - 1] as HTMLElement).focus();
        break;
      }
      default:
        break;
    }
  };

  return (
    <TabBarContainer role='tablist' ref={tabListRef} onKeyDown={handleKeyDown} {...elemProps}>
      {children}
    </TabBarContainer>
  );
};

export default TabBarSwitch;
